<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;" *ngIf="isAnnoncCardDisplayed">
    <mat-card-header class="titree">
        {{ 'Annonces' | translate }}
    </mat-card-header>
    <mat-card-content class="card-content">
        <app-table-commun-fournisseur #tableListAnnonces [data] ="data"  [page]="'listAnnonces'" (openDialogListAttachedFilesEvent)="openDialogListAttachedFiles($event)" (emitNotDisplayAnnonceEvent)="this.isAnnoncCardDisplayed = $event !== 0"></app-table-commun-fournisseur>
    </mat-card-content>
</mat-card>

<div style="margin-top: 4%;">
    <app-fiche-consultation
            [data]="data"
            [label]="label"
            [labels]="labels"
            [dataColumns]="dataColumns"
            [dataColumnsAr]="dataColumnsAr"
            [dataColumnsEn]="dataColumnsEn"
            [langue]="getlang()"
    >
    </app-fiche-consultation>
</div>
<div *ngIf="withopar" fxLayout="row wrap" fxLayoutAlign="end center" class="cp5 mt-2">
    <button mat-raised-button type="button" color="primary" (click)="open()">
        {{ "historique" | translate }}
    </button>
</div>
<div style="margin-top: 4%;">
    <ng-container *ngIf="withopar">
        <app-fiche-consultation
                [data]="data"
                [label]="label2"
                [labels]="lables2"
                [dataColumns]="dataColumns2"
                [dataColumnsAr]="dataColumnsAr2"
                [dataColumnsEn]="dataColumnsEn2"
                [langue]="getlang()"
        >
        </app-fiche-consultation>
    </ng-container>
</div>

<div *ngIf="withopar" class="pc" mat-dialog-actions fxLayoutAlign="end end" >
    <div fxLayout="row wrap" fxLayoutAlign="center center">
        <button (click)="openPageEmail()" style="background-color: #c0392b" color="primary" mat-raised-button>
            {{ "Demande de précisions par email" | translate }}
        </button>
    </div>
</div>

<div *ngIf="withopar">
    <mat-card
            appCard
            style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
    >
        <mat-card-header class="titree">
            {{ "Informations par lot ou article" | translate }}
        </mat-card-header>
        <mat-card-content >
            <div
                    fxFlex="100"
                    fxFlex.gt-sm="100"
                    style="max-width: 100%; justify-content: center"
            >
                <app-tree-table [id]="id"></app-tree-table>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<div *ngIf="withopar">
    <mat-card
            appCard
            style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
    >
        <mat-card-header class="titree">
            {{ "Informations Agréments" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <div
                    fxFlex="100"
                    fxFlex.gt-sm="100"
                    style="max-width: 100%; justify-content: center"
            >
                <app-recap-agrement-table-fo
                        [data]="listAgrement"
                ></app-recap-agrement-table-fo>
            </div>
        </mat-card-content>
    </mat-card>
</div>



<div *ngIf="withopar">
    <mat-card
            appCard
            style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
    >
        <mat-card-header class="titree">
            {{ "Cahier des charges" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <div
                    fxFlex="100"
                    fxFlex.gt-sm="100"
                    style="max-width: 100%; justify-content: center"
            >
                <app-details-list-cahier [id]="id" [specialCase]="['3','4'].includes(data[0]?.procedureType)?'forPqTpListAllAO':''" [aoData]="data" [ourCase]="'fournisseur'"></app-details-list-cahier>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<div *ngIf="withopar && detailsoffre">
    <mat-card
            appCard
            style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2); margin-top: 4%"
    >
        <mat-card-header class="titree">
            {{ "Participation à l'appel d'offres" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <div
                    fxFlex="100"
                    fxFlex.gt-sm="100"
                    style="max-width: 100%; justify-content: center"
            >
                <app-table-participation-fournisseur
                        [epBidMasterId]="epBidMasterId"
                        [bidNo]="id"
                        [data]="data2"
                        [detailsoffre]="detailsoffre"
                        [id]="id"
                ></app-table-participation-fournisseur>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<div style="float: right;" class="mt-2" *ngIf="withopar">
    <button color="primary" mat-raised-button class="mr-2" (click)="openFicheListSoumissionaires()" [disabled]="!checkFlags['soumissionaireRetenu']">
        <span>{{ "Soumissionnaire(s) retenu(s)" | translate}}</span>
    </button>
    <button color="primary" mat-raised-button class="mr-2" (click)="openFicheResultatOuverture()" [disabled]="!checkFlags['resultatOuvPublished']">
        <span>{{ "Résultat" | translate}}</span>
    </button>
</div>
